import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "../../app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class UserRegistrationService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  userRegistrationForm(formData: any, email: string, payload: any): Observable<any> {
    const data = { ...formData, user_email: email, ...payload };
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.USER_REGISTRATION_FORM.USER_REGISTRATION}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  userDataUpdate(email): Observable<any> {
    const params = new HttpParams()
      .set('user_email', email.toString());
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.USER_REGISTRATION_FORM.USER_DATA_UPDATE}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  companyDataUpdate(): Observable<any> {
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.USER_REGISTRATION_FORM.COMPANY_DATA_UPDATE}?user_email=${localStorage.getItem('email') || ''}`,
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  postUserStatus(data: any): Observable<any> {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.USER_REGISTRATION_FORM.USER_DATA_UPDATE}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  UpdateSubscription(data): Observable<any[]> {
    return this.http.put<any[]>(`${AppConstants.API_ENDPOINT}${AppConstants.API.USER_REGISTRATION_FORM.USER_DATA_UPDATE}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  changeUserStatus(data: any) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.USER_REGISTRATION_FORM.CHANGE_COMPANY_STATUS}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  updateCompanyExpiryDate(data: any) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.USER_REGISTRATION_FORM.UPDATE_COMPANY_EXPIRY_DATE}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getProducts(keyword: string): Observable<any> {
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.USER_REGISTRATION_FORM.GET_PRODUCTS}?user_email=${localStorage.getItem('email') || ''}&search=${keyword}`,
    ).pipe(
      catchError((error) => this.errorHandlerService.handleError(error))
    );
  }
}
